import { MathPrimitive } from "../generation/extendMath";

export enum TemplatePartTypes {
  STEP_DELIMITER = "step-delimiter",
  TEXT = "text",
  LATEX = "latex",
  MARKDOWN = "markdown",
  NEWLINE = "newline",
  STATEMENT = "statement",
  INPUT = "input"
}

export enum InputTypes {
  REGULAR = "regular",
  PLACEHOLDER_LATEX = "placeholder-latex",
  SELECT = "select"
}

type BaseTemplatePart = {
  templatePosition: number;
  original: string;
  type: string;
};

export type StepDelimiterPart = BaseTemplatePart & {
  type: TemplatePartTypes.STEP_DELIMITER;
};

export type TextPart = BaseTemplatePart & {
  type: TemplatePartTypes.TEXT;
  value: string;
};

export type LatexPart = BaseTemplatePart & {
  type: TemplatePartTypes.LATEX;
  value: string;
};

export type MrkdwnPart = BaseTemplatePart & {
  type: TemplatePartTypes.MARKDOWN;
  value: string;
};

export type NewLinePart = BaseTemplatePart & {
  type: TemplatePartTypes.NEWLINE;
};

export type StatementPart = BaseTemplatePart & {
  type: TemplatePartTypes.STATEMENT;
  statement: string;
  omitFromScaffold: boolean;
};

type BaseInputPart = BaseTemplatePart & {
  type: TemplatePartTypes.INPUT;
  correctValue: any;
};

export type RegularInputPart = BaseInputPart & {
  inputType: InputTypes.REGULAR;
  correctValue: MathPrimitive;
};

export type SelectInputPart = BaseInputPart & {
  inputType: InputTypes.SELECT;
  randomisedOptions: any[];
};

export type PlaceholderLatexInputPart = BaseInputPart & {
  inputType: InputTypes.PLACEHOLDER_LATEX;
  valueWithPlaceholder: string;
  correctValue: string;
};

export type InputPart =
  | SelectInputPart
  | PlaceholderLatexInputPart
  | RegularInputPart;

export type DelimiterParts = NewLinePart | StepDelimiterPart;

/* Parts which have a string value to render */
export type StringTemplatePart = TextPart | LatexPart | MrkdwnPart;

export type TemplatePart =
  | StringTemplatePart
  | DelimiterParts
  | StatementPart
  | InputPart;
